import { Button, Tag, Typography } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';
import useDashboardStore from '../../stores/dashboardStore';
import useEditorUiStore from '../../stores/editorUiStore';
import ConfigPanel from './ConfigPanel';
import DataBindingPanel from './DataBindingPanel';

const { Text } = Typography;

/**
 * 2026-10-05：3D 场景内「就地编辑」态下，右侧 3D 属性区自动切换为 2D 组件属性。
 * - 组件属性（ConfigPanel）/ 数据绑定（DataBindingPanel，由工具栏切换）
 * - 「返回 3D 属性」= 取消选中 2D 组件 → 右侧恢复 3D 属性面板
 * - 左侧 3D 菜单与详情区（图层/组件树）保持不变
 */
export default function Overlay2DPropsPanel() {
  const components = useDashboardStore((s) => s.components);
  const selectedId = useDashboardStore((s) => s.selectedComponentId);
  const binding = useEditorUiStore((s) => s.overlay2dBinding);
  const comp = components.find((c) => c.id === selectedId);
  if (!comp) return null;

  const name = String((comp as any).base?.title || (comp as any).config?.title || comp.type);

  return (
    <div data-testid="ov-props" style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#1a1a2e' }}>
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px',
          borderBottom: '1px solid #30475e', background: '#16233a', flexShrink: 0,
        }}
      >
        <Text strong style={{ fontSize: 12, color: '#e0e0e0', maxWidth: 120 }} ellipsis>
          {name}
        </Text>
        <Tag color="blue" style={{ marginInlineEnd: 0 }}>{comp.type}</Tag>
        {binding && <Tag color="gold" style={{ marginInlineEnd: 0 }}>数据绑定</Tag>}
        <Button
          size="small"
          type="text"
          data-testid="ov-props-back"
          icon={<RollbackOutlined />}
          style={{ marginLeft: 'auto', flexShrink: 0 }}
          onClick={() => useDashboardStore.getState().selectComponent(null)}
        >
          返回 3D 属性
        </Button>
      </div>
      <div style={{ flex: 1, overflow: 'auto' }}>
        {binding ? <DataBindingPanel /> : <ConfigPanel />}
      </div>
    </div>
  );
}
